import styled from 'styled-components';
import { env } from '@pass-frontend/features/configuration/util';
import { RESPONSIVE_QUERY } from '@pass-frontend/utility/style-helpers';
import { SignInBox, LoginType } from './sign-in-box';
import { FacilityHeader } from '../facility-header/facility-header';

const {
  ENABLE_LOGIN_WITH_MSID,
  ENABLE_LOGIN_WITH_HEALTH_SAFE_ID,
  ENABLE_LOGIN_WITH_OHID,
} = env();

const WidthConstrainer = styled.div`
  max-width: 1272px;
  margin: 0 auto;
  height: 100vh;
  ${RESPONSIVE_QUERY.large} {
    width: 90%;
  }
`;

const ButtonWrapper = styled.div`
  justify-content: center;
  > div:first-child {
    margin-right: 16px;
  }
  ${RESPONSIVE_QUERY.medium} {
    flex-direction: column;
    > div:first-child {
      margin-right: 0;
      margin-bottom: 16px;
    }
  }
`;

export function FacilitySignIn() {
  return (
    <>
      <FacilityHeader shouldHideSignInButton={true} />
      <div className="has-rds-mb-none has-rds-bg-grey-lightest">
        <div className="has-rds-bg-grey-lightest has-rds-pb-64">
          <WidthConstrainer className="has-rds-pv-40">
            <h1 className="is-rds-h1 has-rds-pv-40 has-text-centered">
              Sign In
            </h1>
            <ButtonWrapper className="is-flex">
              {ENABLE_LOGIN_WITH_MSID && (
                <SignInBox
                  title="Sign in for operations and customer support team members"
                  buttonText="Sign in with MSID"
                  loginType={LoginType.MSID}
                />
              )}
              {ENABLE_LOGIN_WITH_OHID === 'true' && (
                <SignInBox
                  title="Sign in for gym vendors/partners"
                  buttonText="Sign in with OneHealthcare ID"
                  loginType={LoginType.OHID}
                />
              )}
            </ButtonWrapper>
          </WidthConstrainer>
        </div>
      </div>
    </>
  );
}
